<template>
  <div>
    <div class="top-header">
      <h3>常见问题</h3>
      <el-input v-model="searchKey" style="width: 300px" placeholder="请输入你需要搜索的内容" @keyup.enter.native="searchEnter" suffix-icon="el-icon-search"/>
    </div>
    <el-collapse v-model="activeNames" style="padding: 10px 30px;">
      <el-collapse-item v-for="(item, index) in showList" :title="item.label" :name="index + 1" :key="index">
        <div v-html="item.value"></div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchKey: '',
      activeNames: [1],
      showList: [],
      questionList: [
        { label: '错误码信息code145003031,msg业务参数签名失败，需要如何处理？', value: 'customercode或者明文密码错误导致，沙箱环境：请检查是否使用的是极兔人员给出的测试数据；生产环境：可前往大客户VIP系统https://vip.bxexpress.com.cn/，使用customercode和明文密码进行登录核实，若忘记密码可直接进行修改。' },
        { label: '错误码信息code145003012,msgAPI账户没接口权限，需要如何处理？', value: '1、首先检查请求的接口地址和公用参数是否为同一环境。<br/>2、生产接口没有审核或者审核未通过，联系极兔管理员进行审核。' },
        { label: '错误码信息code145003030,msgheaders签名失败，需要如何处理？', value: 'headers签名是由privatekey+bizContent 组合生成的签名，如果提示header签名失败，需要检查一下签名方法是否使用正确，可前往帮助中心查看签名规则，和签名工具生成结果进行对比。' },
        { label: '物流轨迹各扫描节点对应的状态是什么？', value: '1、快件揽收——揽件。<br/>2、入仓扫描（停用）——忽略这个值。<br/>3、发件扫描——运输中。<br/>4、到件扫描——运输中，到达中转站。<br/>5、出仓扫描——派件中。<br/>6、入库扫描—— 快递投放快递柜/驿站。<br/>7、代理点收入扫描——快递投放代理点。<br/>8、快件取出扫描——快递从代理点取出。<br/>9、出库扫描——快件从快递柜或快递驿站签收。<br/>10、快件签收——快递签收。<br/>11、问题件扫描——问题件。<br/>注：9&10均属于正常签收。' },
        { label: '正式环境的apiAccount、privateKey、customerCode、password（明文密码）从哪里可以获取？', value: '正式环境apiaccount和privateKey在控制台-个人中心里面查看，支持创建多个应用，以获取多个apiAccount； customerCode和明文密码联系网点给你创建大客户账号密码。' },
        { label: '已经上线的接口，可以再次发起联调吗？', value: '在控制台-应用管理中可以针对已经联调通过的接口再次联调，但不会修改该接口的状态。' },
        { label: '个人中心的应用管理是干什么用的?', value: '当存在多种业务模式时，一个apiAccount可能无法满足需求，需要通过应用管理添加多个apiAccount。' }
      ]
    }
  },
  mounted() {
    this.showList = this.questionList
  },
  methods: {
    searchEnter() {
      if (this.searchKey) {
        this.showList = this.questionList.filter(v => v.label.includes(this.searchKey) || v.value.includes(this.searchKey))
      } else {
        this.showList = this.questionList
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.top-header {
  border-bottom: 1px solid #DCDEE1;
  padding: 0 20px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ::v-deep .el-input__inner {
    border-radius: 6px;
  }
  ::v-deep .el-input__inner:hover {
    border-color: #E60000;
    box-shadow: 0 0 5px #E60000;
  }
}
h3 {
  font-size: 22px;
  color: #2b2d42;
  line-height: 22px;
  display: inline-block;
}
::v-deep .is-active {
  color:#E60000;
}
::v-deep .el-collapse-item__header {
  font-weight: 600;
  font-size: 15px;
  font-family: PingFangSC, PingFangSC-Medium;
}
.el-collapse {
  border-top: none;
}
</style>
